export const formatWhatsAppDate = (value) => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString();
};

export const formatPercent = (value) => `${Number(value || 0).toFixed(1)}%`;

export const normalizeRecipient = (value) => String(value || "").replace(/[^\d]/g, "");

export const parseRecipients = (value) => {
  const seen = new Set();
  return String(value || "")
    .split(/[\n,;]+/)
    .map(normalizeRecipient)
    .filter(Boolean)
    .filter((recipient) => {
      if (seen.has(recipient)) {
        return false;
      }
      seen.add(recipient);
      return true;
    });
};

export const extractErrorMessage = (payload) =>
  payload?.messages?.message ||
  payload?.message ||
  "The WhatsApp message could not be queued";

export const statusColor = (status) => {
  switch (String(status || "").toUpperCase()) {
    case "PENDING":
      return "gold";
    case "PROCESSING":
      return "blue";
    case "SENT":
      return "cyan";
    case "DELIVERED":
      return "green";
    case "READ":
      return "purple";
    case "FAILED":
      return "red";
    default:
      return "default";
  }
};

export const statusChartColor = (status) => {
  switch (String(status || "").toUpperCase()) {
    case "PENDING":
      return "#f59e0b";
    case "PROCESSING":
      return "#2563eb";
    case "SENT":
      return "#06b6d4";
    case "DELIVERED":
      return "#16a34a";
    case "READ":
      return "#7c3aed";
    case "FAILED":
      return "#dc2626";
    default:
      return "#94a3b8";
  }
};

export const trimFilters = (filters) =>
  Object.fromEntries(
    Object.entries(filters || {}).filter(([, value]) => value !== undefined && value !== null && String(value).trim() !== "")
  );

export const truncate = (value, length = 90) => {
  if (!value) {
    return "-";
  }

  const text = String(value);
  return text.length > length ? `${text.substring(0, length - 3)}...` : text;
};
